import { segmentIdentifyTraitsKey } from "../send-persisted-segment-traits"
import { setLocalStorageWithExpiry } from "../../../utils/local-storage"

type SubmissionTraits = {
  firstName?: string
  lastName?: string
  email?: string
}

export function prepareFormSubmittedIdentifyTraits(formData: Array<any>) {
  let traits: SubmissionTraits = {}

  // Translate Hubspot form fields into Segment reserved traits
  // See: https://segment.com/docs/connections/spec/identify/#traits
  for (let formField of formData) {
    if (formField.name === "firstname") {
      traits.firstName = formField.value
    }

    if (formField.name === "lastname") {
      traits.lastName = formField.value
    }

    if (formField.name === "email" && formField.value) {
      traits.email = formField.value.toLowerCase()
    }
  }

  if (Object.keys(traits).length > 0) {
    setLocalStorageWithExpiry(segmentIdentifyTraitsKey, traits, 30)
  }
}
